import * as React from 'react';

import { useToggleButton } from '@fluentui/react-button';

import { useAppButtonState } from '../../AppButton/next';
import { useMergedTooltipAndKeytipRef } from '../../AppButton/next/useMergedTooltipAndKeytipRef';
import { AppToggleButtonProps, AppToggleButtonState } from './AppToggleButton.types';

/**
 * Given user props, returns state for an `AppToggleButton`.
 */
export const useAppToggleButton = (
  props: AppToggleButtonProps,
  ref: React.Ref<HTMLButtonElement>
): AppToggleButtonState => {
  const { disabled, toggled } = props;

  const mergedRefWithKeytip = useMergedTooltipAndKeytipRef(props, ref);

  const toggleButtonState = useToggleButton(
    { ...props, checked: toggled, type: 'button', disabledFocusable: disabled },
    mergedRefWithKeytip
  );

  useAppButtonState(props, toggleButtonState);

  return toggleButtonState;
};
